import {Directive, Input, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {PwaLandingService} from '../services/pwa-landing.service';
import {SidebarService} from '../services/side-bar.service';
import {isStandardsPhone} from '../content-page/my-standards/standards-viewport';

const DEPARTMENT_ROUTE = '/dashboard/groups';
const DEPARTMENT_MENU = 'm-groups';

@Directive({selector: '[appPhonePrimaryDepartment]', exportAs: 'phonePrimaryDepartment'})
export class PhonePrimaryDepartmentLinkDirective implements OnDestroy {
  @Input() appPhonePrimaryDepartment = false;
  pending = false;
  failed = false;
  private destroyed$ = new Subject<void>();
  private destroyed = false;

  constructor(private landing: PwaLandingService, private router: Router, private sidebar: SidebarService) {}

  get isPhone(): boolean { return this.appPhonePrimaryDepartment && isStandardsPhone(); }

  open(): void {
    if (!this.isPhone || this.pending) { return; }
    this.pending = true;
    this.failed = false;
    this.landing.ownDepartment().takeUntil(this.destroyed$).subscribe(
      id => this.navigate(id), () => this.reject());
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private navigate(id: string): void {
    if (!this.isPhone) { this.pending = false; return; }
    this.router.navigate([DEPARTMENT_ROUTE, id]).then(success => {
      if (this.destroyed) { return; }
      this.pending = false;
      if (!this.isPhone) { return; }
      this.failed = !success;
      if (success) {
        this.sidebar.setSelectedMenuOption(DEPARTMENT_MENU);
        this.sidebar.setSideBar(false);
      }
    }, () => this.reject());
  }

  private reject(): void {
    if (this.destroyed) { return; }
    this.pending = false;
    this.failed = true;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/navbar/phone-primary-department-link.directive.ts